import React from 'react';
import PropTypes from 'prop-types';

CheckBoxButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selectedOptions: PropTypes.array.isRequired
};

export default function CheckBoxButton({ index, label, value, selectedOptions }) {
  const inputValue = JSON.parse(value);
  const isChecked = selectedOptions.some(option => option.id === inputValue.id);

  return (
    <li key={index} className="radio" style={{ marginBottom: '8px' }}>
      <input
        type="checkbox"
        name="wb-fieldflow wb-auto-1wb-auto-12"
        id={`legislation-${index}`}
        checked={isChecked}
        data-wb-fieldflow="{&quot;bind&quot;:&quot;legislation-7&quot;}"
        value={value}
        // readOnly since parent form onChange handles the change
        readOnly
        style={{ 
          width: '20px', 
          height: '20px',
          minWidth: '20px', // prevent shrinking
          cursor: 'pointer',
          marginTop: '2px', // align with first line of text
          flexShrink: 0,
        }}
      />
      <label
        htmlFor={`legislation-${index}`}
        style={{
          fontSize: '18px',
          lineHeight: '1.5',
          paddingLeft: '10px',
          cursor: 'pointer',
          // Make entire label area tappable
          display: 'inline-block',
          minHeight: '44px', // Apple recommended min tap target
          verticalAlign: 'top',
          paddingTop: '4px',
        }}
      >
        {label}
      </label>
    </li>
  );
}